import { render, staticRenderFns } from "./OrganizationHeading.vue?vue&type=template&id=4ae83250&scoped=true&"
import script from "./OrganizationHeading.vue?vue&type=script&lang=js&"
export * from "./OrganizationHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae83250",
  null
  
)

export default component.exports